export default __webpack_public_path__ + "images/6U.27b6cba.png";